export const buildRow = (label, value, key = String(label), extra = {}) => ({
  label,
  value,
  key,
  ...extra,
});

export const formatTimestamp = (ts, options) => {
  if (!ts) return 'No timestamp';
  return new Date(ts).toLocaleString(undefined, options);
};

export const formatMetric = (value, unit = '') => {
  if (value == null || value === '*' || Number.isNaN(Number(value))) return 'N/A';
  return `${Number(value).toFixed(2)}${unit ? ` ${unit}` : ''}`;
};
